import LessonDetailsElPage from './container'
export default LessonDetailsElPage
